export { default } from '../forgot-password';

